import { Brick, registerBrick } from 'olympe';
import {createApplicationStore} from '../../components/pr_editor/utils/createApplicationStore';

export default class DefaultApplicationStore extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function(*)} setDefaultAppStore
     */
    update($, inputs, [setDefaultAppStore]) {
        const useApplicationStore = createApplicationStore({
            'dateFormat': null,
            'separator': null,
            'columnsToDisplay': [],
        });

        setDefaultAppStore(useApplicationStore);
    }
}

registerBrick('01911302bd5a6b184104', DefaultApplicationStore);
